import { useCallback } from 'react';
// @ts-ignore virtual module provided by vite-plugin-pwa
import { useRegisterSW } from 'virtual:pwa-register/react';
import { GlassButton } from '../ui/GlassButton';

export function PWAUpdatePrompt() {
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(
      _swUrl: string,
      registration: ServiceWorkerRegistration | undefined,
    ) {
      // Check for updates periodically (every 60 minutes)
      if (registration) {
        setInterval(() => {
          registration.update();
        }, 60 * 60 * 1000);
      }
    },
    onRegisterError(error: Error) {
      console.error('SW registration error:', error);
    },
  });

  const handleUpdate = useCallback(() => {
    updateServiceWorker(true);
  }, [updateServiceWorker]);

  if (!needRefresh) return null;

  return (
    <div
      className="fixed bottom-20 left-4 right-4 sm:left-auto sm:right-4 sm:w-80 z-[70]"
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
      role="alert"
    >
      <div className="flex items-center gap-3 p-4 rounded-[var(--radius-lg)] border border-[var(--glass-border)] bg-[var(--glass-bg-heavy)] backdrop-blur-[var(--glass-blur)] shadow-[var(--glass-shadow)]">
        {/* Icon */}
        <div className="shrink-0 w-10 h-10 rounded-full bg-[var(--brand-primary)]/15 flex items-center justify-center">
          <svg
            className="w-5 h-5 text-[var(--brand-primary)]"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
            />
          </svg>
        </div>

        {/* Text */}
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-[var(--text-primary)]">
            Update Available
          </p>
          <p className="text-xs text-[var(--text-muted)]">
            A new version is ready to install.
          </p>
        </div>

        {/* Action */}
        <GlassButton variant="primary" size="sm" onClick={handleUpdate}>
          Update
        </GlassButton>
      </div>
    </div>
  );
}
